"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializePostIdNavigation = initializePostIdNavigation;
exports.initializeUrlNavigation = void 0;

/**
 * Initializes the URL navigation behavior.
 */
var initializeUrlNavigation = function initializeUrlNavigation() {
  initializePostIdNavigation();
};
/**
 * Initializes the post ID navigation.
 * When the post ID is present in the URL, it will be added to the hash.
 * This matches the registered pattern for the post ID.
 *
 * @example
 * ```
 * /path?postid=123
 * ```
 *
 * Will navigate to:
 * ```
 * /path#post123
 */


exports.initializeUrlNavigation = initializeUrlNavigation;

function initializePostIdNavigation() {
  var postId = new URLSearchParams(globalThis.location.search).get('postid');
  if (postId) globalThis.location.hash = '#post' + postId;
}